/** School-year helpers. An Ontario school year runs September → June, so the
 *  year a date belongs to flips in September, not in January. */

/** En dash, matching how school years are written on a report card. */
const DASH = "–";

const label = (startYear) => `${startYear}${DASH}${startYear + 1}`;

/** The school year containing `date` - e.g. Nov 2025 and Mar 2026 are both 2025-2026. */
export function currentSchoolYear(date = new Date()) {
  const startYear = date.getMonth() >= 8 ? date.getFullYear() : date.getFullYear() - 1;
  return label(startYear);
}

/**
 * Years offered when creating a gradebook: last year (still marking it), this
 * year, and next year (setting up early). Anything older is rare enough that
 * editing the gradebook afterwards is the right path.
 */
export function schoolYearOptions(date = new Date()) {
  const startYear = date.getMonth() >= 8 ? date.getFullYear() : date.getFullYear() - 1;
  return [startYear - 1, startYear, startYear + 1].map(label);
}

/**
 * The calendar span of a school year label, as `YYYY-MM-DD` strings -
 * `"2025–2026"` becomes `{ from: "2025-09-01", to: "2026-06-30" }`.
 *
 * Used to seed the sheet's date filter so it opens showing the whole year
 * rather than an arbitrary window.
 *
 * Splits on any dash: these labels are written with an EN DASH (see `DASH`
 * above, matching how a report card prints them), but a value typed or imported
 * by hand will use a hyphen, and silently failing to parse it would empty the
 * teacher's sheet. Anything unparseable returns nulls, which the filter reads as
 * "unbounded" - showing everything, which is the safe direction to fail.
 */
export function schoolYearRange(schoolYear) {
  const match = String(schoolYear ?? "").match(/(\d{4})\s*[-–—]\s*(\d{4})/);
  if (!match) return { from: null, to: null };
  return { from: `${match[1]}-09-01`, to: `${match[2]}-06-30` };
}
